import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmationService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../models/enums.generated';
import { camps } from '../../../../models/models.generated';
import { DiscountManagementApiService } from '../../../../services/api/discount-management-api.service';
import { CampsDetailsFormBuilder } from '../camp-details-form-builder';
import { CampsDetailsFormStateService } from '../camp-details-form-state-service';

@Component({
    selector: 'app-discounts-list',
    templateUrl: './discounts-list.component.html',
    styleUrls: ['./discounts-list.component.scss'],
    standalone: false
})
export class DiscountsListComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    constructor(
        public state: CampsDetailsFormStateService,
        private formBuilder: CampsDetailsFormBuilder,
        private confirm: ConfirmationService,
        private translate: TranslateService,
        private api: DiscountManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public isEdited(form: UntypedFormGroup) {
        return this.state.isEdited(form);
    }

    public add() {
        var array = this.form.controls['items'] as UntypedFormArray;

        var newItem = this.formBuilder.buildDiscountItem(
            <camps.DiscountDefinitionDetails>{
                type: campsenum.DiscountType.EarlyBird,
                isCartLevel: true,
                isPricingLevel: false
            },
            this.form.get('campId').value
        );

        array.insert(0, newItem);
        // array.updateValueAndValidity();
        // this.change.detectChanges();

        this.state.markAsEdited(newItem);
    }

    public isOtherItemEdited(form: UntypedFormGroup) {
        return this.state.isOtherItemEdited(form);
    }

    public get isAnyItemEdited() {
        return this.state.isAnyItemEdited();
    }

    public onCancel(form: UntypedFormGroup) {
        if (!form.controls['id'].value) {
            this.removeFromArray(form);
        }

        this.state.finishEdit(form, false);
    }

    public edit(form: UntypedFormGroup) {
        this.state.markAsEdited(form);
    }

    public onRemoved(form: UntypedFormGroup) {
        this.confirm
            .show(
                this.translate.instant('CampDetails.RemoveConfirmationTitle'),
                this.translate.instant('CampDetails.RemoveConfirmation')
            )
            .subscribe(result => {
                if (result === true) {
                    var request = <camps.DiscountRemoveRequest>{ discountId: form.get('id').value };

                    this.api.remove(request).subscribe(x => {
                        if (x.isSuccess) {
                            this.removeFromArray(form);
                            this.alert.showOperationSuccess();
                            this.state.discountChanged.emit(request.discountId);
                        } else {
                            this.errorTranslate.translateValidationNotifications(x.validationNotification);
                            this.alert.showError(x.validationNotification.errors[0].message);
                        }
                    });
                }
            });
    }

    private removeFromArray(form: UntypedFormGroup) {
        var arr = this.form.controls['items'] as UntypedFormArray;
        //console.log(arr)
        var index = arr.controls.findIndex(f => f == form);
        arr.removeAt(index);
    }
}
